import React from 'react';
import { useLanguage } from '../Context/LanguageContext';

const LanguageToggle = ({ className = '', style = {} }) => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      className={`lang-toggle ${className}`}
      onClick={toggleLanguage}
      aria-label={`Switch to ${language === 'en' ? 'Arabic' : 'English'}`}
      style={{
        background: 'var(--bg-secondary)',
        border: '1px solid var(--border-color)',
        cursor: 'pointer',
        color: 'var(--text-primary)',
        fontSize: '0.9rem',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'auto',
        minWidth: '50px',
        height: '36px',
        padding: '0 0.75rem',
        borderRadius: '20px',
        transition: 'all 0.3s ease',
        ...style,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'var(--bg-tertiary)';
        e.currentTarget.style.borderColor = 'var(--color-gold)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'var(--bg-secondary)';
        e.currentTarget.style.borderColor = 'var(--border-color)';
      }}
    >
      {language === 'en' ? 'AR' : 'EN'}
    </button>
  );
};

export default LanguageToggle;
